import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Экран настроек, с которого можно уйти с несохранёнными правками. Гард типизирован интерфейсом,
 * а не конкретным компонентом: его обслуживают и редактор скоупов, и экран алёртов по заказам.
 */
export interface IUnsavedSettingsAware {
  readonly hasChanges: boolean;
}

/**
 * Уход со скоупа с несохранёнными изменениями. Переключение подвкладки выглядит
 * безобидно, но пересобирает форму, поэтому спрашиваем явно.
 */
@Injectable()
export class UnsavedSettingsGuard implements CanDeactivate<IUnsavedSettingsAware> {
  constructor(private translate: TranslateService) {
  }

  canDeactivate(component: IUnsavedSettingsAware): boolean {
    if (!component.hasChanges) {
      return true;
    }

    return confirm(this.translate.instant('ADMIN.SETTINGS.LEAVE_CONFIRM'));
  }
}
